(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frenzy-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function(event) {
    frenzyScriptReload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frenzy-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function (event) {
    frenzyScriptReload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown"]) return;
  try {
    
  // ponytail: DST-aware PT offset recalculated per tick via Intl instead of a timezone library
  function getTZOffsetMinutes(timeZone, date) {
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
    return (utcDate.getTime() - tzDate.getTime()) / 60000;
  }

  function ptToUTCTimestamp(dateStr, timeStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    const [hour, minute] = (timeStr || '00:00').split(':').map(Number);
    const naiveUTC = Date.UTC(year, month - 1, day, hour || 0, minute || 0);
    const offsetMinutes = getTZOffsetMinutes('America/Los_Angeles', new Date(naiveUTC));
    return naiveUTC + offsetMinutes * 60000;
  }

  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      this.startTimestamp = ptToUTCTimestamp(this.dataset.startDate, this.dataset.startTime);
      this.endTimestamp = ptToUTCTimestamp(this.dataset.endDate, this.dataset.endTime);
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const now = Date.now();

      if (now < this.startTimestamp || now > this.endTimestamp) {
        this.hidden = true;
        if (now > this.endTimestamp) clearInterval(this.interval);
        return;
      }

      this.hidden = false;

      const remaining = this.endTimestamp - now;
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('promo-countdown', PromoCountdown);

  } catch(e) { console.error(e); }
})();
})();
